"use client"
import { useState, useEffect } from "react"
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

import HomePage from "./components/HeroSection/HeroSection"
import AboutPage from "./components/AboutSection/About"
import MenuPage from "./components/Menu/Menu"
import PromotionRestaurant from "./components/promotionRestaurants/PromotionRestaurant"
import Testimonials from "./components/Testmonials/Testmonial"
import Feature from "./components/Feature/feature"
import GalleryPage from "./components/Gallery/Gallery"
import Blog from "./components/Blog/Blog"
import BlogArticle from "./components/Blog/BlogArticle"
import ContactPage from "./components/Contact/Contact"
import Hiring from "./components/Hiring/Hiring"
import Header from "./components/Header/Header"
import Footer from "./components/Footer/Footer"
import LoadingScreen from "./components/LoadingScreen"
import "./App.css"

function App() {
  const blogPathMatch = window.location.pathname.match(/^\/blog\/([^/]+)\/?$/)
  const blogSlug = blogPathMatch ? decodeURIComponent(blogPathMatch[1]) : null
  const isHiringPage = /^\/hiring\/?$/.test(window.location.pathname)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (blogSlug) return undefined

    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 2000)
    return () => clearTimeout(timer)
  }, [blogSlug])

  if (blogSlug) {
    return <BlogArticle slug={blogSlug} />
  }

  if (isLoading) {
    return <LoadingScreen />
  }

  if (isHiringPage) {
    return (
      <div className="min-vh-100 bg-light overflow-hidden">
        <Header />
        <main className="hiring-dedicated-main"><Hiring /></main>
        <Footer />
      </div>
    )
  }

  return (
    <div className="min-vh-100 bg-light overflow-hidden">
      <Header />
      <main>
        <section id="home"><HomePage /></section>
        <section id="features"><Feature /></section>
        <section id="about"><AboutPage /></section>
        <section id="promotion-restaurants"><PromotionRestaurant /></section>
        <section id="testimonials"><Testimonials /></section>
        <section id="menu"><MenuPage /></section>
        <section id="gallery"><GalleryPage /></section>
        <section id="blog"><Blog /></section>
        <section id="contact"><ContactPage /></section>
      </main>
      <Footer />
    </div>
  )
}

export default App
